module.exports = __webpack_public_path__ + "static/media/PDF.14e86f54.svg";